import { useState, useEffect } from "react";




function GroupKids(props)
{

    const[tab,setTab] = useState(props.tab);
    const[view,setView] = useState("line");


    const changeView = () => {
        if(view == "line")  {setView("list");} else setView("line");
    }


    var persons = tab.length;


    if(view == "list")
    {
        return (
            <div className="link_color" onClick={changeView}>
                {persons} -ukryj-

               <div className="quickPopup shadowx">
                     
                            {  tab.map(  (item, ix) => {

                           

                                    return <div className="qitem">
                                          {item.imie} {item.nazwisko} 
                                    </div>

                            } ) }
                   
               </div>
              

            </div> 
        )
       
    }


    return (
        <div className="link_color" onClick={changeView}>
               {persons} -pokaż-
        </div> 
    )
}

export default GroupKids;